import { useCallback, useEffect, useRef, useState } from 'react';
import { undoDuplicate as undoDuplicateRequest } from './undoDuplicate';
import { Study } from './StudyList';

type PreviousPosition = { studyId: number; position: number };
export const useDuplicateManagement = () => {
  const [undoneStudyIds, setUndoneStudyIds] = useState<Set<Study['id']>>(
    new Set()
  );
  const undoneStudiesRef = useRef(undoneStudyIds);
  const previousStudyPosition = useRef<PreviousPosition | null>(null);

  useEffect(() => {
    undoneStudiesRef.current = undoneStudyIds;
  }, [undoneStudyIds]);

  const markAsDuplicate = useCallback((study: Study) => {
    setUndoneStudyIds((prev) => {
      return new Set(prev.add(study.id));
    });
  }, []);

  const undoDuplicate = useCallback(async (studyId: number) => {
    return undoDuplicateRequest(studyId).then(() => {
      setUndoneStudyIds((prev) => {
        prev.delete(studyId);
        const updated = new Set(prev);
        undoneStudiesRef.current = updated;
        return updated;
      });

      return Promise.resolve(studyId);
    });
  }, []);

  const isDuplicate = (studyId: number) => {
    return undoneStudiesRef.current.has(studyId);
  };

  const renderListItem = (studyId: number, component: JSX.Element | null) => {
    if (isDuplicate(studyId)) return null;

    return component;
  };

  return {
    undoneStudyIds,
    markAsDuplicate,
    undoDuplicate,
    renderListItem,
    previousStudyPosition,
  };
};
